import { h } from 'vue';
import { Tag } from 'ant-design-vue';

/**
 * Renders a status tag with appropriate color based on the status value
 * @param {string} value - The status value to display
 * @returns {VNode|null} - Vue render function result or null if no value
 */
export function renderStatusTag(value) {
  if (!value) return null;

  let statusColor;

  switch (value) {
    case 'Tepat Waktu':
      statusColor = 'green';
      break;
    case 'Terlambat':
      statusColor = 'red';
      break;
    default:
      statusColor = 'blue';
  }

  return h(Tag, { color: statusColor }, () => value);
}
